import { ELabelColor, ILabel } from '../../../types/label';

export function getRosreestrCheckedLabel(): ILabel {
  return {
    tooltip: {
      title: 'Продавец указал кадастровый номер',
      description: 'В объявлении есть информация из Росреестра о собственности, статусе земли, площади дома и участка',
    },
    text: 'Проверено в Росреестре',
    color: ELabelColor.Gray,
  };
}
